import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "hylas_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Small delay so it doesn't flash on initial paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0A0A0A] border-t border-white/10 px-4 py-4 md:py-3"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
        {/* Message */}
        <p className="text-white/70 text-xs leading-relaxed flex-1">
          We use cookies to improve your experience and analyze Site traffic. By continuing to use this site, you agree to our use of cookies.{" "}
          <Link
            to="/privacy"
            className="text-primary hover:underline underline-offset-2"
            onClick={accept}
          >
            Privacy Policy
          </Link>
        </p>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            data-testid="cookie-decline-btn"
            onClick={decline}
            className="font-head text-[10px] uppercase tracking-[0.2em] text-white/50 hover:text-white/80 px-3 py-2 transition-colors duration-200"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="font-head text-[10px] uppercase tracking-[0.2em] bg-primary text-black px-5 py-2 hover:bg-white transition-colors duration-200"
          >
            Accept
          </button>
          <button
            data-testid="cookie-close-btn"
            onClick={decline}
            className="text-white/40 hover:text-white/70 transition-colors duration-200 ml-1"
            aria-label="Close cookie notice"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
